import React from 'react';
import { ShieldCheck, Sparkles } from 'lucide-react';
import type { Book } from '../../../../shared/types/index.js';

interface UibnPreviewCardProps {
  initialBook?: Book | null;
  previewUibn: string;
  isGeneratingUibn: boolean;
  onGenerateNew: () => void;
}

export const UibnPreviewCard: React.FC<UibnPreviewCardProps> = ({
  initialBook,
  previewUibn,
  isGeneratingUibn,
  onGenerateNew,
}) => {
  return (
    <div className="p-4 rounded-xl bg-indigo-50/70 border border-indigo-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div>
        <div className="flex items-center gap-1.5 text-xs font-bold text-indigo-900 uppercase tracking-wide">
          <ShieldCheck className="w-4 h-4 text-indigo-600" />
          <span>{initialBook ? 'Kode UIBN Buku Ini' : 'Pratinjau Kode UIBN Unik'}</span>
        </div>
        <div className="text-lg font-mono font-bold text-indigo-700 mt-1">
          {previewUibn || 'Menghasilkan...'}
        </div>
        <p className="text-[11px] text-indigo-600/80">
          Prefix standar 979 • 4 digit kode penerbit • 4 digit nomor urut • 1 digit modulo-10 checksum
        </p>
      </div>
      {!initialBook && (
        <button
          type="button"
          onClick={onGenerateNew}
          disabled={isGeneratingUibn}
          className="px-3 py-1.5 bg-white hover:bg-indigo-100 text-indigo-700 border border-indigo-200 rounded-lg text-xs font-semibold flex items-center gap-1.5 shadow-2xs transition shrink-0 cursor-pointer disabled:opacity-50"
        >
          <Sparkles className="w-3.5 h-3.5" />
          <span>Acak Kode Baru</span>
        </button>
      )}
    </div>
  );
};
